module.exports = __webpack_public_path__ + "static/img/1.212edae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/1.png
// module id = 4Ael
// module chunks = 0